import { useMutation, useQueryClient } from "react-query";
import { deleteAction } from "@/services/tasks";

/** Mutation hook to soft-delete a suggested action. Refetches the action center so the count stays accurate and the action does not reappear on reopen. */
export function useDeleteAction(patientUid, reminderId) {
  var queryClient = useQueryClient();
  return useMutation(function (actionId) {
    return deleteAction(patientUid, reminderId, actionId);
  }, {
    onSuccess: function onSuccess() {
      queryClient.invalidateQueries(["action-center", patientUid, reminderId]);
    },
    onError: function onError() {}
  });
}